const validateUrlSimplePattern = /^https?:\/\/[a-z\d](?:[a-z\d/.-])*\.[a-z]{2,}(?:\/(?:[^\s])*)?$/i;

const isUrlValid = (url: string) => validateUrlSimplePattern.test(url);

const invalidUrlMessages = {
  required: 'Fülle bitte das Feld aus',
  invalid: 'Gib bitte eine korrekte URL an',
  conflict: 'Dieser Link wurde bereits angegeben. Jede Webseite kann nur einmal verwendet werden.',
} as const;

export const validateUrl = (url: string, otherUrls: Set<string>) => {
  if (!url) return otherUrls.size > 0 || invalidUrlMessages.required;
  if (!isUrlValid(url)) return invalidUrlMessages.invalid;
  if (otherUrls.has(url)) return invalidUrlMessages.conflict;

  return true;
};

export const redirectAppToUrl = (url: string) => {
  window.location.href = url;
};
